module.exports = __webpack_public_path__ + "static/media/AF.14c45ecc.svg";